import { SAVE_FILES } from './actionTypes'
import { YouFirstFilesType } from './types'
import { FilesModel } from '../../requests/downloadFiles/filesModel'

export const saveFiles = (files: FilesModel[]): YouFirstFilesType => {
	return ({
		type: SAVE_FILES,
		payload: files
	})
}
